import { PeekButton, PeekCheckbox, PeekStack, PeekTextField, PeekTypography } from "@piiqtechnologies/ui-components";
import React from "react";
import { PlusCircle } from "@piiqtechnologies/svg-icons";
import messages from "./messages.i18n";
import { useIntl } from "react-intl";
/**
 * AMENITY SELECTOR
 */
const AddCustomAmenity = ({ editMode, toggleEditMode, handleAddAmenity }) => {
    const intl = useIntl();
    if (editMode) {
        return (React.createElement(PeekStack, { direction: "row", alignItems: "center", ml: -1.1, mr: 1.6 },
            React.createElement(PeekCheckbox, { checked: false, color: "success", sx: { py: 0.35 } }),
            React.createElement(PeekTextField, { autoFocus: true, placeholder: intl.formatMessage(messages.addCustomTitle), onBlur: (event) => handleAddAmenity(event.target.value), sx: { input: { p: 0.35, minWidth: 120 }, m: 0 } })));
    }
    return (React.createElement(PeekButton, { "aria-label": "Add Custom Amenity", sx: { minWidth: 90, px: 0.2, ":hover": { bgcolor: "transparent" } }, startIcon: React.createElement(PlusCircle, { height: 20, width: 20 }), onClick: toggleEditMode },
        React.createElement(PeekTypography, { variant: "body1", sx: { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" } }, `${intl.formatMessage(messages.addCustomTitle)}...`)));
};
export default AddCustomAmenity;
